import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { IdentityVerificationMethod, IdentityVerificationMethodLabel, IdentityVerificationStatus, IdentityVerificationStatusLabel } from 'common';

@Component({
    selector: 'ifb-customer-identity-update-dialog',
    templateUrl: './customer-identity-update-dialog.component.html',
    styleUrls: ['./customer-identity-update-dialog.component.scss'],
    standalone: false
})
export class CustomerIdentityUpdateDialogComponent {

  readonly VerificationMethod = IdentityVerificationMethod;
  readonly VerificationMethodLabel = IdentityVerificationMethodLabel;
  readonly VerificationStatus = IdentityVerificationStatus;
  readonly VerificationStatusLabel = IdentityVerificationStatusLabel;

  constructor(public dialogRef: MatDialogRef<CustomerIdentityUpdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  static show(dialog: MatDialog, form: UntypedFormGroup): Observable<any> {
    return dialog.open(CustomerIdentityUpdateDialogComponent, {
      width: '510px',
      data: { form: form },
      closeOnNavigation: true,
    }).afterClosed();
  }
}
